import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// SharedModule dla <app-list-state> w panelu bocznym. Bez cyklu: shared nie siega do voip.
import { SharedModule } from '../shared';

// Components
import { FloatingPhoneComponent } from './components/floating-phone/floating-phone.component';
import { DialPadComponent } from './components/dial-pad/dial-pad.component';
import { VoipSidebarComponent } from './components/voip-sidebar/voip-sidebar.component';

// Directives
import { ClickToCallDirective } from './directives/click-to-call.directive';

/**
 * Moduł widgetu VoIP - ładowany eager (nie lazy).
 * Zawiera tylko FloatingPhoneComponent do wyświetlania na wszystkich stronach.
 *
 * UWAGA: SipService i VoipWorkstationService są providedIn: 'root',
 * więc nie dodajemy ich do providers tutaj (żeby uniknąć tworzenia duplikatów).
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        SharedModule
    ],
    declarations: [
        FloatingPhoneComponent,
        DialPadComponent,
        VoipSidebarComponent,
        ClickToCallDirective
    ],
    exports: [
        FloatingPhoneComponent,
        VoipSidebarComponent,
        ClickToCallDirective
    ]
})
export class VoipWidgetModule { }
